import { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { saveRef } from "@/lib/ref";
import { initI18n, t } from "@/lib/i18n";

export default function RefRedirect() {
  const { refCode } = useParams();
  const navigate = useNavigate();
  const done = useRef(false);
  const [, setI18nReady] = useState(false);

  useEffect(() => {
    initI18n().then(() => setI18nReady(true));
    if (done.current) return;
    done.current = true;
    api.post("/ref/click", { ref_code: refCode })
      .then(({ data }) => { if (data.valid) saveRef(refCode, data.cookie_days); })
      .catch(() => {})
      .finally(() => navigate("/", { replace: true }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div data-testid="ref-redirect" className="min-h-screen bg-gray-50 flex items-center justify-center text-sm text-gray-400">
      {t("dist.redirecting", "Redirecting…")}
    </div>
  );
}
